import { Injectable } from '@angular/core';
import { Customers, BusinessUnits, Facilities } from '../model/customer';
import { RequestParam } from '../model/reverse/physical-inventory';
import { TechVerticalConfig } from '../enrollmentType.config';
import { LookUpCodes } from 'src/app/model/lov';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  customers: Customers;
  businessUnit: BusinessUnits;
  fac: Facilities;

  headerTitle = '';
  enrollmentTypes: string[];
  enrollmentTypeExist: boolean;
  allLanguageList: LookUpCodes[] = [];
  
  constructor() {
    this.enrollmentTypes = TechVerticalConfig.enrollmentTypes;
   }

  getEnrollmentTypes(): string[] {
    return this.enrollmentTypes;
  }

  get headerMenuTitle() {
    if (this.headerTitle === undefined || this.headerTitle === null || this.headerTitle === '') {
      return localStorage.getItem('headerTitle');
    }
    return this.headerTitle;
  }

  set headerMenuTitle(title) {
    this.headerTitle = title;
    localStorage.setItem('headerTitle', title);
  }

  isEnrollmentTypeAvailable(): boolean {
    this.enrollmentTypeExist = this.enrollmentTypes.some(type => type === this.getSelectedCustomer()?.enrollmentType);
    return this.enrollmentTypeExist;
  }

  getSelectedCustomer() {
    return localStorage.getItem('selectedCustomer')
      ? JSON.parse(localStorage.getItem('selectedCustomer'))
      : '';
  }

  getSelectedBusinessUnit() {
    return localStorage.getItem('selectedBusinessUnit')
      ? JSON.parse(localStorage.getItem('selectedBusinessUnit'))
      : '';
  }

  getSelectedFacility() {
    return localStorage.getItem('selectedFacility')
      ? JSON.parse(localStorage.getItem('selectedFacility'))
      : '';
  }

  getUserid() {
    return localStorage.getItem('USERID')
      ? JSON.parse(localStorage.getItem('USERID'))
      : '';
  }

  getReqParam(): RequestParam {
    let reqHeader = new RequestParam();
    reqHeader.custId = this.getSelectedCustomer().customerId?.toString();
    reqHeader.fcyId = this.getSelectedFacility().facilityID?.toString();
    reqHeader.buId = this.getSelectedBusinessUnit().buId?.toString();
    return reqHeader;
  }
  
  getUpdatedValues(original: any, updated: any): any {
    let updatedValues: any = {};

    for (const key in updated) {
      if (updated.hasOwnProperty(key)) {
        if (original[key] !== updated[key]) {
          updatedValues[key] = updated[key];
        } else {
          updatedValues[key] = "";
        }
      }
    }

    if(this.areAllKeysEmpty(updatedValues))
      return updatedValues = {};
    else
      return updatedValues;
  }

  areAllKeysEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).every(key => {
      const value = obj[key];
      // Check if the value is empty
      return value === null || value === undefined || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
    });
  }

}
